import { FormValues } from "./tickets/types";

export const initialFormValue: FormValues = {
  request: '',
  requestDetail: '',
  iAm: '',
  relation: '',
  fullName: '',
  cellNumber: '',
  eMail: '',
  photo: null,
  authorize: false,
  np: '',
  suzano_mail: '',
  segments: [],
  brands: [],
  supplier: '',
  corp_mail: '',
};

export const tipoPedidoPT = [
  {
    id: '1',
    name: 'Solicitar acesso aos seus dados pessoais',
    target: 'Solicitar acesso aos seus dados pessoais',
  },
  {
    id: '2',
    name: 'Solicitar confirmação de tratamento dos dados pessoais',
    target: 'Solicitar confirmação de tratamento dos dados pessoais',
  },
  {
    id: '3',
    name: 'Solicitar portabilidade dos dados pessoais',
    target: 'Solicitar portabilidade dos dados pessoais',
  },
  {
    id: '4',
    name: 'Solicitar correção dos dados pessoais',
    target: 'Solicitar correção dos dados pessoais',
  },
  {
    id: '5',
    name: 'Solicitar exclusão dos dados pessoais',
    target: 'Solicitar exclusão dos dados pessoais',
  },
  {
    id: '6',
    name: 'Solicitar restrição/bloqueio ao tratamento dos dados pessoais',
    target: 'Solicitar restrição/bloqueio ao tratamento dos dados pessoais',
  },
  {
    id: '7',
    name: 'Solicitar oposição ao tratamento dos dados pessoais',
    target: 'Solicitar oposição ao tratamento dos dados pessoais',
  },
  {
    id: '8',
    name: 'Solicitar revogação do consentimento',
    target: 'Solicitar revogação do consentimento',
  },
  {
    id: '9',
    name: 'Solicitar contato do encarregado de proteção de dados pessoais ou DPO para outros assuntos',
    target:
      'Solicitar contato do encarregado de proteção de dados pessoais ou DPO para outros assuntos',
  },
];

export const tipoPedidoEN = [
  {
    id: '1',
    name: 'Request access to your personal data',
    target: 'Request access to your personal data',
  },
  {
    id: '2',
    name: 'Request confirmation of personal data processing',
    target: 'Request confirmation of personal data processing',
  },
  {
    id: '3',
    name: 'Request portability of personal data',
    target: 'Request portability of personal data',
  },
  {
    id: '4',
    name: 'Request correction of personal data',
    target: 'Request correction of personal data',
  },
  {
    id: '5',
    name: 'Request deletion of personal data',
    target: 'Request deletion of personal data',
  },
  {
    id: '6',
    name: 'Request restriction/blocking of personal data processing',
    target: 'Request restriction/blocking of personal data processing',
  },
  {
    id: '7',
    name: 'Request opposition to personal data',
    target: 'Request opposition to personal data',
  },
  {
    id: '8',
    name: 'Request revocation of consent',
    target: 'Request revocation of consent',
  },
  {
    id: '9',
    name: 'Request contact witch the Personal Data Protection Office (DPO) for other matters',
    target:
      'Request contact witch the Personal Data Protection Office (DPO) for other matters',
  },
];

export const tipoPedidoES = [
  {
    id: '1',
    name: 'Solicitar acesso a sus datos personales',
    target: 'Solicitar acesso a sus datos personales',
  },
  {
    id: '2',
    name: 'Solicitar confirmación de tratamiento de datos personales',
    target: 'Solicitar confirmación de tratamiento de datos personales',
  },
  {
    id: '3',
    name: 'Solicitar portabilidad de datos personales',
    target: 'Solicitar portabilidad de datos personales',
  },
  {
    id: '4',
    name: 'Solicitar corrección de datos personales',
    target: 'Solicitar corrección de datos personales',
  },
  {
    id: '5',
    name: 'Solicitar la eliminación de datos personales',
    target: 'Solicitar la eliminación de datos personales',
  },
  {
    id: '6',
    name: 'Solicitar restricción/bloqueo del tratamiento de datos personales',
    target: 'Solicitar restricción/bloqueo del tratamiento de datos personales',
  },
  {
    id: '7',
    name: 'Solicitar oposición al tratamiento de datos personales',
    target: 'Solicitar oposición al tratamiento de datos personales',
  },
  {
    id: '8',
    name: 'Solicitar revocación de consentimiento',
    target: 'Solicitar revocación de consentimiento',
  },
  {
    id: '9',
    name: 'Solicitar contacto del Delegado de Protección de Datos Personales o DPO para otros asuntos',
    target:
      'Solicitar contacto del Delegado de Protección de Datos Personales o DPO para otros asuntos',
  },
];

export const listaRelacaoPT = [
  { id: '1', name: 'Colaborador(a)', target: 'Colaborador(a)' },
  { id: '2', name: 'Ex-Colaborador(a)', target: 'Ex-Colaborador(a)' },
  {
    id: '3',
    name: 'Dependente ou familiar de Colaborador(a)',
    target: 'Dependente ou familiar de Colaborador(a)',
  },
  { id: '4', name: 'Candidato(a) à Emprego', target: 'Candidato(a) à Emprego' },
  {
    id: '5',
    name: 'Destinatário de Marketing',
    target: 'Destinatário de Marketing',
  },
  { id: '6', name: 'Cliente', target: 'Cliente' },
  { id: '7', name: 'Consumidor Final', target: 'Consumidor Final' },
  {
    id: '8',
    name: 'Fornecedor ou Prestador de Serviço',
    target: 'Fornecedor ou Prestador de Serviço',
  },
  { id: '9', name: 'Outros', target: 'Outros' },
];

export const listaRelacaoES = [
  { id: '1', name: 'Contribuyente', target: 'Contribuyente' },
  { id: '2', name: 'Empleado', target: 'Empleado' },
  {
    id: '3',
    name: 'Dependiente o familiar del empleado',
    target: 'Dependiente o familiar del empleado',
  },
  { id: '4', name: 'Candidato de trabajo', target: 'Candidato de trabajo' },
  {
    id: '5',
    name: 'Cliente potencial o prospecto',
    target: 'Cliente potencial o prospecto',
  },
  { id: '6', name: 'Cliente', target: 'Cliente' },
  { id: '7', name: 'Consumidor Final', target: 'Consumidor Final' },
  {
    id: '8',
    name: 'Proveedor o prestador de servicios',
    target: 'Proveedor o prestador de servicios',
  },
  {
    id: '9',
    name: 'Representante Legal del Titular Datos Personales',
    target: 'Representante Legal del Titular Datos Personales',
  },
  { id: '10', name: 'Outros', target: 'Outros' },
];

export const listaRelacaoEN = [
  { id: '1', name: 'Employee', target: 'Employee' },
  { id: '2', name: 'Former Employee', target: 'Former Employee' },
  {
    id: '3',
    name: 'Dependent or family member of employee',
    target: 'Dependent or family member of employee',
  },
  {
    id: '4',
    name: 'Candidate for Employment',
    target: 'Candidate for Employment',
  },
  { id: '5', name: 'Lead or Prospect', target: 'Lead or Prospect' },
  { id: '6', name: 'Client', target: 'Client' },
  { id: '7', name: 'Final Consumer', target: 'Final Consumer' },
  {
    id: '8',
    name: 'Supplier or Service Provider',
    target: 'Supplier or Service Provider',
  },
  {
    id: '8',
    name: 'Legal Representative of Personal Data Subject',
    target: 'Legal Representative of Personal Data Subject',
  },
  { id: '9', name: 'Others', target: 'Others' },
];

export const quemSouPT = [
  {
    id: '1',
    name: 'Titular dos dados Pessoais',
    target: 'Titular dos dados Pessoais',
  },
  { id: '1', name: 'Representante Legal', target: 'Representante Legal' },
];

export const quemSouEN = [
  { id: '1', name: 'Personal Data Subject', target: 'Personal Data Subject' },
  { id: '1', name: 'Legal Representative', target: 'Legal Representative' },
];

export const quemSouES = [
  {
    id: '1',
    name: 'Titular de los Datos Personales',
    target: 'Titular de los Datos Personales',
  },
  { id: '1', name: 'Representante Legal', target: 'Representante Legal' },
];

export const brands = [
  'Alta Alvura Alcalino',
  'Alta Alvura Laser',
  'Bluecup',
  'Bluecup Bio',
  'Copimax',
  'Design Gloss Couché Suzano',
  'Design Matte Couché Suzano',
  'Ecolig',
  'Econoclean',
  'Eucafluff',
  'Fit Gloss Couché Suzano',
  'Fit Silk Couché Suzano',
  'Floral',
  'La Vie Blanc',
  'Loop',
  'Loop+',
  'Max Pure',
  'Max Baby',
  'Mimmo',
  'Paperfect',
  'Paperfect Laser',
  'Pólen Bold',
  'Pólen Soft',
  'Press Gloss Couché Suzano',
  'Press Matte Couché Suzano',
  'Reciclato',
  'Repport Colorido',
  'Repport Premium',
  'Repport Reciclato',
  'Repport Senninha',
  'Scala',
  'Super 6 Plus',
  'Supremo Alta Alvura',
  'Supremo Duo Design',
  'TP White Pharma Plus',
  'TP White Plus',
];

export const segments = [
  'Papel',
  'Fluff',
  'Celulose',
  'Bens de Consumo',
  'Lignina',
  'Instituto Ecofuturo',
];
